import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  fullScreenContainer: {
    fontFamily: '"AppFont", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    height: '100%',
    position: 'relative',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  defaultInnerPageStyles: {
    flexDirection: 'column',
    padding: '30px',
    height: 'auto',
    [theme.breakpoints.down('md')]: {
      padding: '20px',
      height: '100%',
    },
  },
  flatshowLink: {
    position: 'fixed',
    bottom: '10px',
    right: '10px',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  polygonsSwitch: (props: {isMobileScreen: boolean}) => ({
    position: 'fixed',
    bottom: props.isMobileScreen ? '68px' : '46px',
    right: props.isMobileScreen ? '20px' : '32px',
    display: 'flex',
  }),
  flatshowLogo: {
    width: '32px',
    height: '34px',
  },
}));
